// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RMQCDj2fZHqlQw8rpCmy {
  padding: 0 0.4em 0 0.8em;
  background-color: var(--background);
}
.RMQCDj2fZHqlQw8rpCmy table {
  width: 100%;
  border-spacing: 0;
  table-layout: fixed;
  cursor: default;
  user-select: none;
}
.RMQCDj2fZHqlQw8rpCmy table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
.RMQCDj2fZHqlQw8rpCmy table thead th {
  background-color: var(--background);
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 2px;
  border-bottom: 8px solid transparent;
  box-sizing: border-box;
  position: relative;
}
.RMQCDj2fZHqlQw8rpCmy table thead th > i {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 2px;
  margin: 0 3px;
  background-color: var(--border-color);
  cursor: col-resize;
}
.RMQCDj2fZHqlQw8rpCmy table thead th:last-child::after {
  display: none;
}
.RMQCDj2fZHqlQw8rpCmy table thead th.sorted {
  padding-right: calc(1.5em + 8px);
}
.RMQCDj2fZHqlQw8rpCmy table thead th:not(:last-child) {
  cursor: pointer;
}
.RMQCDj2fZHqlQw8rpCmy table thead th:not(:last-child) span {
  position: absolute;
  top: -0.1em;
  right: 2px;
  font-size: 2em;
}
.RMQCDj2fZHqlQw8rpCmy table thead th.drop {
  cursor: ew-resize;
}
.RMQCDj2fZHqlQw8rpCmy table thead th.drop > i {
  background-color: var(--selected-color);
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr {
  animation: appear 0.4s linear 1;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr > td {
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: transparent;
  overflow-y: hidden;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr > td:first-child {
  border-left-width: 1px;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr > td:last-child {
  border-right-width: 1px;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr.dragover > td {
  background-color: var(--drop-background) !important;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td {
  --icon-size: 0.8rem;
  padding: 0.08em 0;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child {
  width: 100%;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div {
  display: flex;
  align-items: center;
  gap: 0 0.3em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div.expanded > .icon {
  transform: rotate(90deg);
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div > .icon {
  opacity: 0.6;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div > .fileicon {
  opacity: 0.8;
  width: 1rem;
  height: 1rem;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div > .fileicon::before {
  font-size: 1rem;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div > span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div > ul {
  flex: auto 1 1;
  display: flex;
  justify-content: end;
  gap: 1em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child > div > ul > .icon {
  font-size: 1.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child:not(.d):not(.i) > div {
  padding-left: calc(var(--icon-size) + 0.3em);
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="1"] {
  padding-left: 0.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="2"] {
  padding-left: 1.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="3"] {
  padding-left: 1.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="4"] {
  padding-left: 2.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="5"] {
  padding-left: 3em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="6"] {
  padding-left: 3.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="7"] {
  padding-left: 4.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="8"] {
  padding-left: 4.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="9"] {
  padding-left: 5.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="10"] {
  padding-left: 6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="11"] {
  padding-left: 6.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="12"] {
  padding-left: 7.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="13"] {
  padding-left: 7.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="14"] {
  padding-left: 8.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="15"] {
  padding-left: 9em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="16"] {
  padding-left: 9.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="17"] {
  padding-left: 10.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="18"] {
  padding-left: 10.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="19"] {
  padding-left: 11.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="20"] {
  padding-left: 12em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="21"] {
  padding-left: 12.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="22"] {
  padding-left: 13.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="23"] {
  padding-left: 13.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="24"] {
  padding-left: 14.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="25"] {
  padding-left: 15em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="26"] {
  padding-left: 15.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="27"] {
  padding-left: 16.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="28"] {
  padding-left: 16.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="29"] {
  padding-left: 17.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="30"] {
  padding-left: 18em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="31"] {
  padding-left: 18.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="32"] {
  padding-left: 19.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="33"] {
  padding-left: 19.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="34"] {
  padding-left: 20.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="35"] {
  padding-left: 21em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="36"] {
  padding-left: 21.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="37"] {
  padding-left: 22.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="38"] {
  padding-left: 22.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="39"] {
  padding-left: 23.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="40"] {
  padding-left: 24em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="41"] {
  padding-left: 24.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="42"] {
  padding-left: 25.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="43"] {
  padding-left: 25.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="44"] {
  padding-left: 26.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="45"] {
  padding-left: 27em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="46"] {
  padding-left: 27.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="47"] {
  padding-left: 28.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="48"] {
  padding-left: 28.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="49"] {
  padding-left: 29.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="50"] {
  padding-left: 30em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="51"] {
  padding-left: 30.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="52"] {
  padding-left: 31.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="53"] {
  padding-left: 31.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="54"] {
  padding-left: 32.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="55"] {
  padding-left: 33em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="56"] {
  padding-left: 33.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="57"] {
  padding-left: 34.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="58"] {
  padding-left: 34.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="59"] {
  padding-left: 35.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="60"] {
  padding-left: 36em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="61"] {
  padding-left: 36.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="62"] {
  padding-left: 37.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="63"] {
  padding-left: 37.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="64"] {
  padding-left: 38.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="65"] {
  padding-left: 39em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="66"] {
  padding-left: 39.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="67"] {
  padding-left: 40.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="68"] {
  padding-left: 40.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="69"] {
  padding-left: 41.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="70"] {
  padding-left: 42em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="71"] {
  padding-left: 42.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="72"] {
  padding-left: 43.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="73"] {
  padding-left: 43.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="74"] {
  padding-left: 44.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="75"] {
  padding-left: 45em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="76"] {
  padding-left: 45.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="77"] {
  padding-left: 46.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="78"] {
  padding-left: 46.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="79"] {
  padding-left: 47.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="80"] {
  padding-left: 48em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="81"] {
  padding-left: 48.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="82"] {
  padding-left: 49.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="83"] {
  padding-left: 49.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="84"] {
  padding-left: 50.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="85"] {
  padding-left: 51em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="86"] {
  padding-left: 51.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="87"] {
  padding-left: 52.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="88"] {
  padding-left: 52.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="89"] {
  padding-left: 53.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="90"] {
  padding-left: 54em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="91"] {
  padding-left: 54.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="92"] {
  padding-left: 55.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="93"] {
  padding-left: 55.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="94"] {
  padding-left: 56.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="95"] {
  padding-left: 57em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="96"] {
  padding-left: 57.6em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="97"] {
  padding-left: 58.2em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="98"] {
  padding-left: 58.8em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="99"] {
  padding-left: 59.4em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:first-child[data-depth="100"] {
  padding-left: 60em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td:not(:last-child) {
  padding-right: 0.5em;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr td.type-number {
  text-align: right;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr.selected {
  background-color: var(--selected-background);
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr.selected > td,
.RMQCDj2fZHqlQw8rpCmy table tbody tr.selected > td > div > span {
  color: var(--selected-color);
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr:hover {
  background-color: var(--hover-background);
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr.up {
  opacity: 0.6;
}
.RMQCDj2fZHqlQw8rpCmy table tbody tr.up .icon {
  transform: rotate(90deg);
  font-size: 1.1em;
}
.RMQCDj2fZHqlQw8rpCmy table th,
.RMQCDj2fZHqlQw8rpCmy table td {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.RMQCDj2fZHqlQw8rpCmy:focus tr.target > td {
  border-color: var(--active-border-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `RMQCDj2fZHqlQw8rpCmy`,
	"sorted": `sorted`,
	"drop": `drop`,
	"dragover": `dragover`,
	"expanded": `expanded`,
	"icon": `icon`,
	"fileicon": `fileicon`,
	"d": `d`,
	"i": `i`,
	"typeNumber": `type-number`,
	"selected": `selected`,
	"up": `up`,
	"target": `target`
};
export default ___CSS_LOADER_EXPORT___;
